/**
 * The purpose of this is to continue displaying data even when id changes to null.
 * This is convenient when the same id controls a modal open state,
 * and you want to continue displaying data in the modal while the modal closes.
 *
 * Case 1: null -> "A": undefined
 * Note that the query can still return data if it is found in the cache.
 *
 * Case 2: "A" -> null: value when "A"
 * Will display the previous data when id changes to null.
 *
 * Case 3: "A" -> "B": undefined
 * Note that the query can still return data if it is found in the cache.
 */
export function createPreviousOnNullPlaceholderDataFn<T>(id: unknown) {
  return (previousData: T | undefined) => {
    if (id !== null || previousData === undefined) {
      return undefined;
    } else {
      return previousData;
    }
  };
}
